/** Configuração tipada do frontend (Vite só injeta variáveis VITE_*). */

export type AuthMode = 'local' | 'keycloak';

const authMode: AuthMode = import.meta.env.VITE_AUTH_MODE === 'keycloak' ? 'keycloak' : 'local';

/**
 * Base da API. Vazio = mesma origem, que é o caso no dev (o proxy /api do Vite
 * responde) e continua válido se um dia API e SPA voltarem a dividir host.
 * Em produção o SPA vive no Cloudflare Pages e a API no cluster, em origens
 * diferentes (ADR-018), então isto precisa apontar para https://erp-api.fatorh.ai.
 */
const apiBaseUrl = (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '');

export const env = {
  /** 'local' (e-mail/senha do próprio ERP) ou 'keycloak' (SSO). */
  authMode,
  apiBaseUrl,
  keycloak: {
    url: import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8081',
    // realm = produto, organization = inquilino (ADR-019); o nome antigo do
    // realm era o do primeiro cliente — spec 017 tirou a marca dele do bundle
    realm: import.meta.env.VITE_KEYCLOAK_REALM || 'erp',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'erp-web',
  },
} as const;

export const isKeycloakMode = env.authMode === 'keycloak';
